<div class="grid field col-12">
  @if (loading || saving) {
    <div class="grid field col-12">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <div>
      <div class="grid field col-12">
        <!--Page Title and Dashboard Link-->
        <div class="col-12 md:col-2">
          <h2>Operator Job Details</h2>
        </div>
        <div class="col-12 md:col-2">
          <button pButton  (click)="navigateToDashboard()"
            style="margin-top:17px; height:30px; width:145px; float:right; vertical-align:bottom;">
            <i pButtonIcon class="far fa-chart-bar"></i>
            <span pButtonLabel>Dashboard</span>
          </button>
        </div>
        <div class="col-12 md:col-2">
          <button pButton  (click)="showManageFiles = true"
            style="margin-top:17px; height:30px; width:145px; float:right; vertical-align:bottom;">
            <i pButtonIcon class="far fa-chart-bar"></i>
            <span pButtonLabel>Files</span>
          </button>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Job Number</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{job.number}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Company</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{consumerCompanyName}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Well Api Number</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{job.wellApiNumber}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Arrive on Loc/Begin RU on Well</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{job.startTime | date:'short'}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Release from Loc/RD from Well</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{job.endTime | date:'short'}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Job Type</label>
          </div>
          <div class="col-12 md:col-6">
            <label class="readOnly-label">{{job.workbookType}}</label>
          </div>
        </div>
        <div class="grid field col-12">
          <div class="col-12 md:col-2">
            <label>Service Providers</label>
          </div>
          <div class="col-12 md:col-6">
            <p-multiSelect [options]="vendorCompanies" [(ngModel)]="selectedVendorCompanyIds" (onChange)="vendorCompanyIdsChanged()"></p-multiSelect>
          </div>
        </div>
      </div>
      @if (vendorJobsReady) {
        <div class="grid field col-12">
          <p-accordion>
            @for (vendorJob of vendorJobs; track vendorJob; let i = $index) {
              <p-accordion-panel [value]="i">
                <p-accordion-header>{{getVendorCompanyName(vendorJob)}} - {{vendorJob.name}}</p-accordion-header>
                <p-accordion-content>
                  <app-vendor-job-common [ngModel]="vendorJob" [disabled]="true" [showWorkbookLink]="true" [consumerJobId]="job.id ?? ''" [securityToken]="securityToken"></app-vendor-job-common>
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      }
    </div>
  }
</div>

<!-- Files Dialog -->
@if (showManageFiles) {
  <p-dialog header="Job Files" [(visible)]="showManageFiles">
    <app-filelist [consumerJobId]="jobId" [isVendorJob]="false"></app-filelist>
    <p-footer>
      <button type="button" pButton (click)="showManageFiles = false">
        <i pButtonIcon class="pi pi-check"></i>
        <span pButtonLabel>Close</span>
      </button>
    </p-footer>
  </p-dialog>
}
